import { createReducer, createAction } from "@reduxjs/toolkit";
import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { selectors as authSelectors } from "./auth";

import {
  fetchTrajectoryLiMsdCurve,
  fetchTrajectoryTfsiMsdCurve,
  // fetchTrajectoryStructure,
  fetchTrajectoryConditions,
} from "../lib/api";

export const actions = {
  request_trajectory_data: createAction("REQUEST_TRAJECTORY_DATA"),
  receive_trajectory_data: createAction("RECEIVE_TRAJECTORY_DATA"),
  receive_trajectory_data_failed: createAction("RECEIVE_TRAJECTORY_DATA_FAILED"),
};

export const constants = {
  NOT_SELECTED: "NOT_SELECTED",
  LOADED: "LOADED",
  LOADING: "LOADING",
  ERROR: "ERROR",
};

export const initState = {
  trajectory_id: -1,
  loadingState: constants.NOT_SELECTED,
  li_msd_curve: {
    time: [],
    msd: [],
  },
  tfsi_msd_curve: {
    time: [],
    msd: [],
  },
  structure: null,
  conditions: {},
};

export const actionMap = {
  [actions.request_trajectory_data]: (state, action) => {
    state.loadingState = constants.LOADING;

    state.trajectory_id = state.trajectory_id === action.payload.trajectory_id ? -1 : action.payload.trajectory_id;

    return state;
  },
  [actions.receive_trajectory_data]: (state, action) => {
    if (state.trajectory_id === -1) {
      state.loadingState = constants.NOT_SELECTED;
      return state;
    }
    state.loadingState = constants.LOADED;

    state.li_msd_curve = action.payload.li_msd_curve;
    state.tfsi_msd_curve = action.payload.tfsi_msd_curve;
    state.structure = action.payload.structure;
    state.conditions = action.payload.conditions;

    return state;
  },
  [actions.receive_trajectory_data_failed]: (state) => {
    state.loadingState = constants.ERROR;

    return state;
  },
};

export const reducer = createReducer(initState, actionMap);

const getMdTrajectoryData = (state) => state.mdTrajectoryData;
export const selectors = {
  getMdTrajectoryData,
};

function* onFetchTrajectoryData(action) {
  try {
    const { trajectory_id } = action.payload;
    if (trajectory_id !== -1) {
      const { accessToken } = yield select(authSelectors.getAuth);
      const [
        {
          data: { li_msd_curve },
        },
        {
          data: { tfsi_msd_curve },
        },
        // {
        //   data: { structure },
        // },
        {
          data: { conditions },
        },
      ] = yield all([
        call(fetchTrajectoryLiMsdCurve, { trajectory_id, accessToken }),
        call(fetchTrajectoryTfsiMsdCurve, { trajectory_id, accessToken }),
        // call(fetchTrajectoryStructure, { trajectory_id, accessToken }),
        call(fetchTrajectoryConditions, { trajectory_id, accessToken }),
      ]);

      yield put(
        actions.receive_trajectory_data({
          li_msd_curve,
          tfsi_msd_curve,
          // structure,
          conditions,
        })
      );
    }
  } catch (e) {
    console.warn(e);
    yield put(actions.receive_trajectory_data_failed());
  }
}

export const sagas = {
  watchEveryRequestTrajectoryData: function* watchEveryRequestTrajectoryData() {
    yield takeLatest(actions.request_trajectory_data.toString(), onFetchTrajectoryData);
  },
};
